import React from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { FileExplorerModalProps } from '../../../types/fileExplorerTypes';
import { ControlledModal } from '../../common/ControlledModal';
import { editFolder, TreeFolder } from '../services';
import {
  editFolderSchema, EditFolderSchema,
} from '../Forms/schemas';
import { useFileExplorerMutation } from '../../../hooks/useFileExplorerMutation';
import { EditFolderForm } from '../Forms/EditFolderForm';

const GENERIC_ERROR_MESSAGE = 'Ocurrió un error al renombrar la carpeta, por favor intenta nuevamente.';

export function EditFolderModal({ show, onHide, data }: FileExplorerModalProps<TreeFolder>) {
  if (!data) return null;

  const form = useForm<EditFolderSchema>({
    resolver: zodResolver(editFolderSchema),
    values: {
      name: data.name,
      description: data.description,
      remove_file_prefix: data.remove_file_prefix,
    },
  });

  const mutationFn = (values: EditFolderSchema) => editFolder(data.id, values);
  const {
    mutateAsync, isLoading,
  } = useFileExplorerMutation({
    mutationFn,
    onSuccess: onHide,
  });

  const handleEdit = (values: EditFolderSchema) => {
    const editPromise = mutateAsync(values);
    toast.promise(editPromise, {
      loading: 'Actualizando carpeta...',
      success: 'Carpeta actualizada exitosamente',
      error: {
        message: 'Error al actualizar la carpeta',
        description: GENERIC_ERROR_MESSAGE,
      },
    });
  };
  return (
    <ControlledModal
      show={show}
      onHide={onHide}
      title="Editar carpeta"
      closeButton
      centered
    >
      <Modal.Body>
        <EditFolderForm form={form} onSubmit={handleEdit}>
          <ControlledModal.Actions handleClose={onHide!} isPending={isLoading} cancelButton />
        </EditFolderForm>
      </Modal.Body>
    </ControlledModal>
  );
}
